/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:5e09e8b6-01e1-42f3-97e5-f40936abbaf2",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_XqlCBaoEs",
    "aws_user_pools_web_client_id": "fcqo4f7rbqkh90do8oedkn1pu",
    "oauth": {
        "domain": "partymeister-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://webapp.partymeister.tv/,myapp://",
        "redirectSignOut": "http://localhost:3000/,https://webapp.partymeister.tv/,myapp://",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "partymeisterstorage143420-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
